export default async function ({ store, redirect }) {
  const tokenBearer= store.state.admin.auth.token
  if (!tokenBearer) {
    return redirect('/admin/auth/login')
  }
}
